import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Tooltip,
} from '@mui/material';
import NotesIcon from '@mui/icons-material/Notes';
import DownloadDoneIcon from '@mui/icons-material/DownloadDone';
import DialogContentText from '@mui/material/DialogContentText';
import React, { FC, useState } from 'react';
import ReviewService from '../../services/ReviewService';

interface Props {
  note: string | undefined;
  id: string | number;
  type?: string;
}
const Note: FC<Props> = ({ note, id, type }) => {
  const [noticeIsOpen, setNoticeIsOpen] = useState<boolean>(false);
  const [notice, setNotice] = useState<string>(note || '');
  const [tempNote, setTempNote] = useState<string>('');

  const handleClickOpenNotice = () => {
    setTempNote(notice);
    setNoticeIsOpen(true);
  };

  const handleClose = () => {
    setTempNote('');
    setNoticeIsOpen(false);
  };

  const handleTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTempNote(event.target.value);
  };

  const handleSave = async () => {
    if (!type) return;

    await ReviewService.saveNote(id, tempNote, type);
    setTimeout(() => setNotice(tempNote), 0);
    setNoticeIsOpen(false);

    return;
  };

  return (
    <div>
      {notice === '' ? (
        <Tooltip
          title={'Notizen hinterlegen'}
          arrow
        >
          <IconButton
            size="small"
            onClick={handleClickOpenNotice}
          >
            <NotesIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip
          title={'Notizen hinterlegen'}
          arrow
        >
          <IconButton
            size="small"
            onClick={handleClickOpenNotice}
          >
            <DownloadDoneIcon
              fontSize="small"
              color={'success'}
            />
          </IconButton>
        </Tooltip>
      )}
      <Dialog
        open={noticeIsOpen}
        onClose={handleClose}
        sx={{
          '& .MuiDialog-paper': {
            width: '100%',
            maxWidth: 500,
            maxHeight: '60%',
            height: '50%',
            margin: 0,
            borderRadius: 0,
          },
          '& .MuiDialog-paperScrollPaper': {
            maxHeight: '100%',
          },
          '& .MuiInputBase-input': {
            overflow: 'hidden',
          },
        }}
      >
        <DialogTitle>Notizen</DialogTitle>
        <DialogContent>
          <DialogContentText>Hier können Sie Notizen hinterlegen</DialogContentText>
          <TextField
            id="outlined-multiline-static"
            multiline
            rows={10}
            fullWidth
            placeholder={'Notizen'}
            margin={'normal'}
            defaultValue={tempNote}
            onChange={handleTextChange}
            sx={{
              '& .MuiInputBase-input': {
                overflow: 'hidden',
              },
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Abbrechen</Button>
          <Button onClick={handleSave}>Speichern</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Note;
